const title = '培诺'
export function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}`
  }
  return `${title}`
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * 判断当前运行环境（普通浏览器/微信小程序/微信内置浏览器）
 * @returns {'browser' | 'miniprogram' | 'wechat'} - 返回当前环境类型
 *   'browser' 表示普通浏览器
 *   'miniprogram' 表示微信小程序
 *   'wechat' 表示微信内置浏览器
 */
export function getWeChatEnv() {
  const ua = navigator.userAgent.toLowerCase()

  if (ua.indexOf('micromessenger') === -1) {
    return 'browser' // 普通浏览器
  }

  if (window.__wxjs_environment === 'miniprogram') {
    return 'miniprogram' // 微信小程序
  }

  return 'wechat' // 微信公众号内置浏览器
}

/**
 * 获取 URL 参数值（兼容 hash 和 history 模式）
 * @param {string} name - 参数名
 * @returns {string|null} - 参数值，不存在返回 null
 */
export function getQueryParam(name) {
  let query = ''

  // 判断是否为 hash 模式
  if (window.location.hash && window.location.hash.includes('?')) {
    // hash 模式：从 hash 中提取参数
    query = window.location.hash.split('?')[1]
  } else {
    // history 模式：从 search 中提取参数
    query = window.location.search.substring(1)
  }

  if (!query) return null

  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === name) {
      // 解码 URL 参数，支持中文和特殊字符
      return decodeURIComponent(pair[1] || '')
    }
  }

  return null
}

/**
 * 获取所有 URL 参数（兼容 hash 和 history 模式）
 * @returns {object} - 参数对象
 */
export function getAllQueryParams() {
  let query = ''

  // 判断是否为 hash 模式
  if (window.location.hash && window.location.hash.includes('?')) {
    query = window.location.hash.split('?')[1]
  } else {
    query = window.location.search.substring(1)
  }

  const params = {}
  if (!query) return params

  const vars = query.split('&')
  vars.forEach(item => {
    const pair = item.split('=')
    const key = decodeURIComponent(pair[0])
    const value = decodeURIComponent(pair[1] || '')
    params[key] = value
  })

  return params
}

/**
 * 使用 URLSearchParams 实现（更现代的方式）
 * @param {string} name - 参数名
 * @returns {string|null}
 */
export function getQueryParamModern(name) {
  let search = ''

  // 获取查询字符串
  if (window.location.hash && window.location.hash.includes('?')) {
    // hash 模式
    search = window.location.hash.split('?')[1]
  } else {
    // history 模式
    search = window.location.search.substring(1)
  }

  if (!search) return null

  const params = new URLSearchParams(search)
  return params.get(name)
}

/**
 * 完整版：支持同时存在 hash 和 query 参数的情况
 * @param {string} name - 参数名
 * @param {string} mode - 'auto'(自动), 'hash'(仅hash), 'query'(仅query)
 * @returns {string|null}
 */
export function getQueryParamFull(name, mode = 'auto') {
  let search = ''

  if (mode === 'auto') {
    // 优先从 hash 中查找
    if (window.location.hash && window.location.hash.includes('?')) {
      search = window.location.hash.split('?')[1]
    }
    // 如果 hash 中没找到，再从 query 中查找
    else if (window.location.search) {
      search = window.location.search.substring(1)
    }
  } else if (mode === 'hash') {
    // 仅从 hash 中查找
    if (window.location.hash && window.location.hash.includes('?')) {
      search = window.location.hash.split('?')[1]
    }
  } else if (mode === 'query') {
    // 仅从 query 中查找
    search = window.location.search.substring(1)
  }

  if (!search) return null

  const params = new URLSearchParams(search)
  return params.get(name)
}

/**
 * 验证手机号是否有效
 * @param {string} phone - 手机号
 * @returns {Object} { valid: boolean, message: string }
 */
export function validatePhone(phone) {
  if (!phone) {
    return {
      valid: false,
      message: '请输入手机号'
    }
  }

  // 去除空格
  phone = phone.trim()

  // 手机号正则表达式(中国大陆)
  const phoneReg = /^1[3-9]\d{9}$/

  if (!phoneReg.test(phone)) {
    return {
      valid: false,
      message: '请输入正确的手机号'
    }
  }

  return {
    valid: true,
    message: ''
  }
}
